export default {
      id: "warning-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.1790760972825.svg#warning-usage",
      toString: function () {
        return this.url;
      }
    }